import React from 'react';
import { Container } from 'react-bootstrap';

const TermsPage = () => (
  <Container className="py-5" style={{ maxWidth: 800 }}>
    <h1>Terms of Service</h1>
    <p className="text-muted">Last updated: July 17, 2026</p>
    <p>
      mikewilliams.us is the personal website of Mike Williams, provided as-is for informational
      purposes. Its private admin tools are for use by the site owner only.
    </p>
    <p>
      Content on this site is provided without warranty of any kind. Nothing on this site
      constitutes professional, financial, or medical advice.
    </p>
    <p>
      Third-party integrations (such as Oura) are used solely to sync the site owner's own data at
      his request and are subject to those services' own terms. Questions can be sent to
      mike@mikewilliams.us.
    </p>
  </Container>
);

export default TermsPage;
